import styled, { css } from 'styled-components';
import { Wrapper as Radio, Dot as RadioDot } from '@/pages/common/inputs/Radio/Radio.styles';

export const Wrapper = styled.article``;

export const Content = styled.div`
  ${({ theme }) => css`
    font-family: ${theme.v2.font.family.primary};
    line-height: ${theme.v2.font.lineHeight.text};
    color: ${theme.v2.colors.neutral.lowDark};
    padding: 0;
  `}
`;

export const Header = styled.header``;

export const Title = styled.h1`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-family: ${theme.v2.font.family.primary};
    font-weight: ${theme.v2.font.weights.medium};
    font-size: ${theme.v2.font.sizes.md};
    margin: 0 0 24px 0;
    padding: 0;
  `}
`;

export const Description = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xs};
    padding: 0;
    margin: 0 0 16px 0;

    p {
      margin: 8px 0 0 0;
    }
  `}    
`;

export const OptionList = styled.ul`
  list-style: none;
  margin: 24px 0 0;
  padding: 0;
`;

export const OptionItem = styled.li`
  ${({ theme, checked }) => css`
    border: 1px solid;
    border-radius: 8px;
    border-color: ${checked ? theme.v2.colors.brand.primaryMedium : theme.v2.colors.neutral.highMedium};
    box-shadow: ${checked ? '0 0 20px 0 #0070d133' : 'none'};

    &:not(:first-child) {
      margin-top: 16px;
    }

    &:hover {
      cursor: pointer;
    }
  `}
`;

export const OptionItemWrapper = styled.div`
  display: flex;
  padding: 16px;
  gap: 16px;
`;

export const OptionRadio = styled.div`
  ${({ theme, checked }) => css`

    ${Radio} {
      border-color: ${checked ? theme.v2.colors.neutral.primaryMedium : theme.v2.colors.brand.lowLight};
    }

    ${RadioDot} {
      background-color: ${checked ? theme.v2.colors.brand.primaryMedium : theme.v2.colors.brand.primaryMedium};
      height: 8px;
      width: 8px;
    }
  `}
`;

export const OptionContent = styled.div``;

export const OptionLabel = styled.label`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
  `}
`;

export const OptionDescription = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xxs};
  `}
`;

export const Controls = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 24px;

    @media (max-width: ${theme.v3.breakpoints.sm}) {
      flex-direction: column;
      gap: 16px;
      align-items: stretch;
    }
  `}
`;
